/**
 * Postgres TEXT and JSONB reject U+0000. JSONB also rejects unpaired
 * UTF-16 surrogates. PDF/DOCX extract and LLM copies often embed both.
 */
const POSTGRES_UNSAFE_CHARS = /[\u0000\uD800-\uDFFF]/g;

export function sanitizePostgresText(value: string): string {
  return value.replace(POSTGRES_UNSAFE_CHARS, '');
}

export function sanitizeJsonStrings(value: unknown): unknown {
  if (typeof value === 'string') return sanitizePostgresText(value);
  if (Array.isArray(value)) return value.map(sanitizeJsonStrings);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, nested]) => [
        key,
        sanitizeJsonStrings(nested),
      ]),
    );
  }
  return value;
}
